<template>
  <div>
    <alert :success=false :display=error text="Le mot de passe n'a pas pu être mis à jour"
           type="error"
           v-on:error="setDisplay('error')"/>

    <alert :success=true :display=success text="Mot de passe mis à jour avec succès"
           type="success"
           v-on:success="setDisplay('success')"/>

    <form @submit="formSubmit" class="ml-2 mt-4">
      <div class="form-group row text-left">
        <label class="col-sm-4 col-form-label text-left text-sm-right ml-sm-0 mb-sm-1 mx-3 mb-1"
               for="passwordInput"> Nouveau mot de passe
        </label>
        <div class="col-sm-7">
          <input id="passwordInput" type="password" class="form-control"
                 :class="{ 'is-invalid': this.$v.password.$error }"
                 @input="$v.password.$touch()"
                 v-model="password"
                 @focus="passwordFlag = true"
                 @blur="passwordFlag = false"
          >
          <div v-if="passwordFlag">

            <div class="row mt-2">
              <div class="col-sm-10 col-md-6" :class="{ 'text-success': this.$v.password.required,
                               'text-danger': !this.$v.password.required }">
                Champ Requis
              </div>
              <div class="col-sm-10 col-md-6" :class="{ 'text-success': this.$v.password.length,
                               'text-danger': !this.$v.password.length }">
                8 caractères
              </div>
              <div class="col-sm-10 col-md-6" :class="{ 'text-success': this.$v.password.number,
                               'text-danger': !this.$v.password.number }">
                1 chiffre
              </div>
              <div class="col-sm-10 col-md-6" :class="{ 'text-success': this.$v.password.upper,
                               'text-danger': !this.$v.password.upper }">
                1 majuscule
              </div>
              <div class="col sm-10" :class="{ 'text-success': this.$v.password.special,
                               'text-danger': !this.$v.password.special }">
                1 caractère spécial
              </div>
            </div>
          </div>
        </div>
        <label class="col-sm-4 col-form-label text-left text-sm-right +
          ml-sm-0 mb-sm-1 mx-3 mb-1 mt-2 mt-sm-0"
          for="passwordInput"> Confirmation
        </label>
        <div class="col-sm-7">
          <input id="passwordConfirmInput" type="password" class="form-control"
                 :class="{ 'is-invalid': this.$v.cPassword.$error }"
                 @input="$v.cPassword.$touch()"
                 v-model="cPassword">
          <div class="row mt-2">
            <div class="text-danger col-sm-10"
                 v-if="!this.$v.cPassword.sameAs && $v.cPassword.$error">
              Les mots de passe ne sont pas identiques
            </div>
          </div>
        </div>
      </div>
      <button class="btn btn-success float-right"
              :disabled=" this.$v.password.$invalid
                       || this.$v.cPassword.$invalid"
              :class="{ 'disabled': this.$v.password.$invalid
                                 || this.$v.cPassword.$invalid
               }">
        Confirmer
      </button>
      <!--Bouton désactivé si le formulaire est invalide-->
    </form>

  </div>
</template>

<script>
import axios from 'axios';
import { required, sameAs } from 'vuelidate/lib/validators';
import Alert from '../Alert.vue';

export default {
  data() {
    return {
      error: 'none',
      success: 'none',
      password: '',
      cPassword: '',
      passwordFlag: false,
    };
  },
  methods: {
    setDisplay(displayable) {
      if (displayable === 'error') this.error = 'none';
      if (displayable === 'success') this.success = 'none';
    },
    formSubmit(e) {
      e.preventDefault();
      axios.post('/auth/api/front/reset', JSON.stringify({
        token: this.$route.query.token,
        password: this.password,
      }), { headers: { 'content-type': 'application/json' } })
        .then(() => {
          window.location.href = `${window.location.origin}/auth?source=${encodeURI(this.$parent.source)}`;
        })
        .catch(() => {
          this.error = 'block';
        });
    },
  },
  props: {
    name: String,
    license: String,
  },
  // Règles de validation du formulaire
  validations: {
    password: {
      length: (password) => password.length >= 8,
      required,
      number: (password) => /[0-9]/.test(password),
      upper: (password) => /[A-Z]/.test(password),
      special: (password) => /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/.test(password),
    },
    cPassword: {
      sameAs: sameAs('password'),
      required,
    },
  },
  components: { Alert },
};
</script>
